import BrowserStorage from '@common/utils/storage/BrowserStorage';

const storageManager = new BrowserStorage(sessionStorage, 'SW');

export default {
  getItem: <T>(key: string): T | null => storageManager.getItem<T>(key),
  saveItem: <T>(key: string, value: T): boolean => storageManager.saveItem<T>(key, value),
  removeItem: (key: string): boolean => storageManager.removeItem(key),
  unPrefixKey: (key: string | null) => storageManager.unPrefixKey(key),
};
